/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthRouteRouteImport } from './routes/_auth/route'
import { Route as CarriersRouteImport } from './routes/carriers'
import { Route as LoginRouteImport } from './routes/login'
import { Route as MagicLoginRouteImport } from './routes/magic-login'
import { Route as AuthErrorRouteImport } from './routes/_auth/error'
import { Route as AuthNotFoundRouteImport } from './routes/_auth/not-found'
import { Route as AuthUnauthorizedRouteImport } from './routes/_auth/unauthorized'
import { Route as CarrierOnboardTokenRouteImport } from './routes/carrier-onboard/$token'
import { Route as OnboardConfirmJoinRouteImport } from './routes/onboard/confirm-join'
import { Route as TenantSlugDriverOnboardingSplatRouteImport } from './routes/$tenantSlug/driver-onboarding/$'
import { Route as AuthCarriersSlugRouteRouteImport } from './routes/_auth/carriers/$slug/route'
import { Route as OnboardFlowTokenIndexRouteImport } from './routes/onboard/$flow.$token.index'
import { Route as OnboardFlowTokenCreateAccountRouteImport } from './routes/onboard/$flow.$token.create-account'
import { Route as OnboardFlowTokenSuccessRouteImport } from './routes/onboard/$flow.$token.success'
import { Route as AuthCarriersSlugDriverOnboardingDashboardRouteImport } from './routes/_auth/carriers/$slug/driver-onboarding/dashboard'
import { Route as AuthCarriersSlugDriverOnboardingDocumentsRouteImport } from './routes/_auth/carriers/$slug/driver-onboarding/documents'
import { Route as AuthCarriersSlugDriverOnboardingInsuranceCertificateRouteImport } from './routes/_auth/carriers/$slug/driver-onboarding/insurance-certificate'
import { Route as AuthCarriersSlugDriverOnboardingInsuranceQuoteRouteImport } from './routes/_auth/carriers/$slug/driver-onboarding/insurance-quote'
import { Route as AuthCarriersSlugDriverOnboardingOnboardingRouteImport } from './routes/_auth/carriers/$slug/driver-onboarding/onboarding'
import { Route as AuthCarriersSlugDriverOnboardingProfileRouteImport } from './routes/_auth/carriers/$slug/driver-onboarding/profile'
import { Route as AuthCarriersSlugDriverOnboardingSignedRouteImport } from './routes/_auth/carriers/$slug/driver-onboarding/signed'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const CarriersRoute = CarriersRouteImport.update({
  id: '/carriers',
  path: '/carriers',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const MagicLoginRoute = MagicLoginRouteImport.update({
  id: '/magic-login',
  path: '/magic-login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthErrorRoute = AuthErrorRouteImport.update({
  id: '/error',
  path: '/error',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthNotFoundRoute = AuthNotFoundRouteImport.update({
  id: '/not-found',
  path: '/not-found',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthUnauthorizedRoute = AuthUnauthorizedRouteImport.update({
  id: '/unauthorized',
  path: '/unauthorized',
  getParentRoute: () => AuthRouteRoute,
} as any)
const CarrierOnboardTokenRoute = CarrierOnboardTokenRouteImport.update({
  id: '/carrier-onboard/$token',
  path: '/carrier-onboard/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardConfirmJoinRoute = OnboardConfirmJoinRouteImport.update({
  id: '/onboard/confirm-join',
  path: '/onboard/confirm-join',
  getParentRoute: () => rootRouteImport,
} as any)
const TenantSlugDriverOnboardingSplatRoute =
  TenantSlugDriverOnboardingSplatRouteImport.update({
    id: '/$tenantSlug/driver-onboarding/$',
    path: '/$tenantSlug/driver-onboarding/$',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthCarriersSlugRouteRoute = AuthCarriersSlugRouteRouteImport.update({
  id: '/carriers/$slug',
  path: '/carriers/$slug',
  getParentRoute: () => AuthRouteRoute,
} as any)
const OnboardFlowTokenIndexRoute = OnboardFlowTokenIndexRouteImport.update({
  id: '/onboard/$flow/$token/',
  path: '/onboard/$flow/$token/',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardFlowTokenCreateAccountRoute =
  OnboardFlowTokenCreateAccountRouteImport.update({
    id: '/onboard/$flow/$token/create-account',
    path: '/onboard/$flow/$token/create-account',
    getParentRoute: () => rootRouteImport,
  } as any)
const OnboardFlowTokenSuccessRoute = OnboardFlowTokenSuccessRouteImport.update({
  id: '/onboard/$flow/$token/success',
  path: '/onboard/$flow/$token/success',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCarriersSlugDriverOnboardingDashboardRoute =
  AuthCarriersSlugDriverOnboardingDashboardRouteImport.update({
    id: '/driver-onboarding/dashboard',
    path: '/driver-onboarding/dashboard',
    getParentRoute: () => AuthCarriersSlugRouteRoute,
  } as any)
const AuthCarriersSlugDriverOnboardingDocumentsRoute =
  AuthCarriersSlugDriverOnboardingDocumentsRouteImport.update({
    id: '/driver-onboarding/documents',
    path: '/driver-onboarding/documents',
    getParentRoute: () => AuthCarriersSlugRouteRoute,
  } as any)
const AuthCarriersSlugDriverOnboardingInsuranceCertificateRoute =
  AuthCarriersSlugDriverOnboardingInsuranceCertificateRouteImport.update({
    id: '/driver-onboarding/insurance-certificate',
    path: '/driver-onboarding/insurance-certificate',
    getParentRoute: () => AuthCarriersSlugRouteRoute,
  } as any)
const AuthCarriersSlugDriverOnboardingInsuranceQuoteRoute =
  AuthCarriersSlugDriverOnboardingInsuranceQuoteRouteImport.update({
    id: '/driver-onboarding/insurance-quote',
    path: '/driver-onboarding/insurance-quote',
    getParentRoute: () => AuthCarriersSlugRouteRoute,
  } as any)
const AuthCarriersSlugDriverOnboardingOnboardingRoute =
  AuthCarriersSlugDriverOnboardingOnboardingRouteImport.update({
    id: '/driver-onboarding/onboarding',
    path: '/driver-onboarding/onboarding',
    getParentRoute: () => AuthCarriersSlugRouteRoute,
  } as any)
const AuthCarriersSlugDriverOnboardingProfileRoute =
  AuthCarriersSlugDriverOnboardingProfileRouteImport.update({
    id: '/driver-onboarding/profile',
    path: '/driver-onboarding/profile',
    getParentRoute: () => AuthCarriersSlugRouteRoute,
  } as any)
const AuthCarriersSlugDriverOnboardingSignedRoute =
  AuthCarriersSlugDriverOnboardingSignedRouteImport.update({
    id: '/driver-onboarding/signed',
    path: '/driver-onboarding/signed',
    getParentRoute: () => AuthCarriersSlugRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/carriers': typeof CarriersRoute
  '/login': typeof LoginRoute
  '/magic-login': typeof MagicLoginRoute
  '/error': typeof AuthErrorRoute
  '/not-found': typeof AuthNotFoundRoute
  '/unauthorized': typeof AuthUnauthorizedRoute
  '/carrier-onboard/$token': typeof CarrierOnboardTokenRoute
  '/onboard/confirm-join': typeof OnboardConfirmJoinRoute
  '/carriers/$slug': typeof AuthCarriersSlugRouteRouteWithChildren
  '/$tenantSlug/driver-onboarding/$': typeof TenantSlugDriverOnboardingSplatRoute
  '/onboard/$flow/$token/create-account': typeof OnboardFlowTokenCreateAccountRoute
  '/onboard/$flow/$token/success': typeof OnboardFlowTokenSuccessRoute
  '/onboard/$flow/$token/': typeof OnboardFlowTokenIndexRoute
  '/carriers/$slug/driver-onboarding/dashboard': typeof AuthCarriersSlugDriverOnboardingDashboardRoute
  '/carriers/$slug/driver-onboarding/documents': typeof AuthCarriersSlugDriverOnboardingDocumentsRoute
  '/carriers/$slug/driver-onboarding/insurance-certificate': typeof AuthCarriersSlugDriverOnboardingInsuranceCertificateRoute
  '/carriers/$slug/driver-onboarding/insurance-quote': typeof AuthCarriersSlugDriverOnboardingInsuranceQuoteRoute
  '/carriers/$slug/driver-onboarding/onboarding': typeof AuthCarriersSlugDriverOnboardingOnboardingRoute
  '/carriers/$slug/driver-onboarding/profile': typeof AuthCarriersSlugDriverOnboardingProfileRoute
  '/carriers/$slug/driver-onboarding/signed': typeof AuthCarriersSlugDriverOnboardingSignedRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/carriers': typeof CarriersRoute
  '/login': typeof LoginRoute
  '/magic-login': typeof MagicLoginRoute
  '/error': typeof AuthErrorRoute
  '/not-found': typeof AuthNotFoundRoute
  '/unauthorized': typeof AuthUnauthorizedRoute
  '/carrier-onboard/$token': typeof CarrierOnboardTokenRoute
  '/onboard/confirm-join': typeof OnboardConfirmJoinRoute
  '/carriers/$slug': typeof AuthCarriersSlugRouteRouteWithChildren
  '/$tenantSlug/driver-onboarding/$': typeof TenantSlugDriverOnboardingSplatRoute
  '/onboard/$flow/$token/create-account': typeof OnboardFlowTokenCreateAccountRoute
  '/onboard/$flow/$token/success': typeof OnboardFlowTokenSuccessRoute
  '/onboard/$flow/$token': typeof OnboardFlowTokenIndexRoute
  '/carriers/$slug/driver-onboarding/dashboard': typeof AuthCarriersSlugDriverOnboardingDashboardRoute
  '/carriers/$slug/driver-onboarding/documents': typeof AuthCarriersSlugDriverOnboardingDocumentsRoute
  '/carriers/$slug/driver-onboarding/insurance-certificate': typeof AuthCarriersSlugDriverOnboardingInsuranceCertificateRoute
  '/carriers/$slug/driver-onboarding/insurance-quote': typeof AuthCarriersSlugDriverOnboardingInsuranceQuoteRoute
  '/carriers/$slug/driver-onboarding/onboarding': typeof AuthCarriersSlugDriverOnboardingOnboardingRoute
  '/carriers/$slug/driver-onboarding/profile': typeof AuthCarriersSlugDriverOnboardingProfileRoute
  '/carriers/$slug/driver-onboarding/signed': typeof AuthCarriersSlugDriverOnboardingSignedRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteRouteWithChildren
  '/carriers': typeof CarriersRoute
  '/login': typeof LoginRoute
  '/magic-login': typeof MagicLoginRoute
  '/_auth/error': typeof AuthErrorRoute
  '/_auth/not-found': typeof AuthNotFoundRoute
  '/_auth/unauthorized': typeof AuthUnauthorizedRoute
  '/carrier-onboard/$token': typeof CarrierOnboardTokenRoute
  '/onboard/confirm-join': typeof OnboardConfirmJoinRoute
  '/_auth/carriers/$slug': typeof AuthCarriersSlugRouteRouteWithChildren
  '/$tenantSlug/driver-onboarding/$': typeof TenantSlugDriverOnboardingSplatRoute
  '/onboard/$flow/$token/create-account': typeof OnboardFlowTokenCreateAccountRoute
  '/onboard/$flow/$token/success': typeof OnboardFlowTokenSuccessRoute
  '/onboard/$flow/$token/': typeof OnboardFlowTokenIndexRoute
  '/_auth/carriers/$slug/driver-onboarding/dashboard': typeof AuthCarriersSlugDriverOnboardingDashboardRoute
  '/_auth/carriers/$slug/driver-onboarding/documents': typeof AuthCarriersSlugDriverOnboardingDocumentsRoute
  '/_auth/carriers/$slug/driver-onboarding/insurance-certificate': typeof AuthCarriersSlugDriverOnboardingInsuranceCertificateRoute
  '/_auth/carriers/$slug/driver-onboarding/insurance-quote': typeof AuthCarriersSlugDriverOnboardingInsuranceQuoteRoute
  '/_auth/carriers/$slug/driver-onboarding/onboarding': typeof AuthCarriersSlugDriverOnboardingOnboardingRoute
  '/_auth/carriers/$slug/driver-onboarding/profile': typeof AuthCarriersSlugDriverOnboardingProfileRoute
  '/_auth/carriers/$slug/driver-onboarding/signed': typeof AuthCarriersSlugDriverOnboardingSignedRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/carriers'
    | '/login'
    | '/magic-login'
    | '/error'
    | '/not-found'
    | '/unauthorized'
    | '/carrier-onboard/$token'
    | '/onboard/confirm-join'
    | '/carriers/$slug'
    | '/$tenantSlug/driver-onboarding/$'
    | '/onboard/$flow/$token/create-account'
    | '/onboard/$flow/$token/success'
    | '/onboard/$flow/$token/'
    | '/carriers/$slug/driver-onboarding/dashboard'
    | '/carriers/$slug/driver-onboarding/documents'
    | '/carriers/$slug/driver-onboarding/insurance-certificate'
    | '/carriers/$slug/driver-onboarding/insurance-quote'
    | '/carriers/$slug/driver-onboarding/onboarding'
    | '/carriers/$slug/driver-onboarding/profile'
    | '/carriers/$slug/driver-onboarding/signed'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/carriers'
    | '/login'
    | '/magic-login'
    | '/error'
    | '/not-found'
    | '/unauthorized'
    | '/carrier-onboard/$token'
    | '/onboard/confirm-join'
    | '/carriers/$slug'
    | '/$tenantSlug/driver-onboarding/$'
    | '/onboard/$flow/$token/create-account'
    | '/onboard/$flow/$token/success'
    | '/onboard/$flow/$token'
    | '/carriers/$slug/driver-onboarding/dashboard'
    | '/carriers/$slug/driver-onboarding/documents'
    | '/carriers/$slug/driver-onboarding/insurance-certificate'
    | '/carriers/$slug/driver-onboarding/insurance-quote'
    | '/carriers/$slug/driver-onboarding/onboarding'
    | '/carriers/$slug/driver-onboarding/profile'
    | '/carriers/$slug/driver-onboarding/signed'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/carriers'
    | '/login'
    | '/magic-login'
    | '/_auth/error'
    | '/_auth/not-found'
    | '/_auth/unauthorized'
    | '/carrier-onboard/$token'
    | '/onboard/confirm-join'
    | '/_auth/carriers/$slug'
    | '/$tenantSlug/driver-onboarding/$'
    | '/onboard/$flow/$token/create-account'
    | '/onboard/$flow/$token/success'
    | '/onboard/$flow/$token/'
    | '/_auth/carriers/$slug/driver-onboarding/dashboard'
    | '/_auth/carriers/$slug/driver-onboarding/documents'
    | '/_auth/carriers/$slug/driver-onboarding/insurance-certificate'
    | '/_auth/carriers/$slug/driver-onboarding/insurance-quote'
    | '/_auth/carriers/$slug/driver-onboarding/onboarding'
    | '/_auth/carriers/$slug/driver-onboarding/profile'
    | '/_auth/carriers/$slug/driver-onboarding/signed'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  CarriersRoute: typeof CarriersRoute
  LoginRoute: typeof LoginRoute
  MagicLoginRoute: typeof MagicLoginRoute
  CarrierOnboardTokenRoute: typeof CarrierOnboardTokenRoute
  OnboardConfirmJoinRoute: typeof OnboardConfirmJoinRoute
  TenantSlugDriverOnboardingSplatRoute: typeof TenantSlugDriverOnboardingSplatRoute
  OnboardFlowTokenCreateAccountRoute: typeof OnboardFlowTokenCreateAccountRoute
  OnboardFlowTokenSuccessRoute: typeof OnboardFlowTokenSuccessRoute
  OnboardFlowTokenIndexRoute: typeof OnboardFlowTokenIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/carriers': {
      id: '/carriers'
      path: '/carriers'
      fullPath: '/carriers'
      preLoaderRoute: typeof CarriersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/magic-login': {
      id: '/magic-login'
      path: '/magic-login'
      fullPath: '/magic-login'
      preLoaderRoute: typeof MagicLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/error': {
      id: '/_auth/error'
      path: '/error'
      fullPath: '/error'
      preLoaderRoute: typeof AuthErrorRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/not-found': {
      id: '/_auth/not-found'
      path: '/not-found'
      fullPath: '/not-found'
      preLoaderRoute: typeof AuthNotFoundRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/unauthorized': {
      id: '/_auth/unauthorized'
      path: '/unauthorized'
      fullPath: '/unauthorized'
      preLoaderRoute: typeof AuthUnauthorizedRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/carrier-onboard/$token': {
      id: '/carrier-onboard/$token'
      path: '/carrier-onboard/$token'
      fullPath: '/carrier-onboard/$token'
      preLoaderRoute: typeof CarrierOnboardTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboard/confirm-join': {
      id: '/onboard/confirm-join'
      path: '/onboard/confirm-join'
      fullPath: '/onboard/confirm-join'
      preLoaderRoute: typeof OnboardConfirmJoinRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$tenantSlug/driver-onboarding/$': {
      id: '/$tenantSlug/driver-onboarding/$'
      path: '/$tenantSlug/driver-onboarding/$'
      fullPath: '/$tenantSlug/driver-onboarding/$'
      preLoaderRoute: typeof TenantSlugDriverOnboardingSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/carriers/$slug': {
      id: '/_auth/carriers/$slug'
      path: '/carriers/$slug'
      fullPath: '/carriers/$slug'
      preLoaderRoute: typeof AuthCarriersSlugRouteRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/onboard/$flow/$token/': {
      id: '/onboard/$flow/$token/'
      path: '/onboard/$flow/$token'
      fullPath: '/onboard/$flow/$token/'
      preLoaderRoute: typeof OnboardFlowTokenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboard/$flow/$token/create-account': {
      id: '/onboard/$flow/$token/create-account'
      path: '/onboard/$flow/$token/create-account'
      fullPath: '/onboard/$flow/$token/create-account'
      preLoaderRoute: typeof OnboardFlowTokenCreateAccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboard/$flow/$token/success': {
      id: '/onboard/$flow/$token/success'
      path: '/onboard/$flow/$token/success'
      fullPath: '/onboard/$flow/$token/success'
      preLoaderRoute: typeof OnboardFlowTokenSuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/carriers/$slug/driver-onboarding/dashboard': {
      id: '/_auth/carriers/$slug/driver-onboarding/dashboard'
      path: '/driver-onboarding/dashboard'
      fullPath: '/carriers/$slug/driver-onboarding/dashboard'
      preLoaderRoute: typeof AuthCarriersSlugDriverOnboardingDashboardRouteImport
      parentRoute: typeof AuthCarriersSlugRouteRoute
    }
    '/_auth/carriers/$slug/driver-onboarding/documents': {
      id: '/_auth/carriers/$slug/driver-onboarding/documents'
      path: '/driver-onboarding/documents'
      fullPath: '/carriers/$slug/driver-onboarding/documents'
      preLoaderRoute: typeof AuthCarriersSlugDriverOnboardingDocumentsRouteImport
      parentRoute: typeof AuthCarriersSlugRouteRoute
    }
    '/_auth/carriers/$slug/driver-onboarding/insurance-certificate': {
      id: '/_auth/carriers/$slug/driver-onboarding/insurance-certificate'
      path: '/driver-onboarding/insurance-certificate'
      fullPath: '/carriers/$slug/driver-onboarding/insurance-certificate'
      preLoaderRoute: typeof AuthCarriersSlugDriverOnboardingInsuranceCertificateRouteImport
      parentRoute: typeof AuthCarriersSlugRouteRoute
    }
    '/_auth/carriers/$slug/driver-onboarding/insurance-quote': {
      id: '/_auth/carriers/$slug/driver-onboarding/insurance-quote'
      path: '/driver-onboarding/insurance-quote'
      fullPath: '/carriers/$slug/driver-onboarding/insurance-quote'
      preLoaderRoute: typeof AuthCarriersSlugDriverOnboardingInsuranceQuoteRouteImport
      parentRoute: typeof AuthCarriersSlugRouteRoute
    }
    '/_auth/carriers/$slug/driver-onboarding/onboarding': {
      id: '/_auth/carriers/$slug/driver-onboarding/onboarding'
      path: '/driver-onboarding/onboarding'
      fullPath: '/carriers/$slug/driver-onboarding/onboarding'
      preLoaderRoute: typeof AuthCarriersSlugDriverOnboardingOnboardingRouteImport
      parentRoute: typeof AuthCarriersSlugRouteRoute
    }
    '/_auth/carriers/$slug/driver-onboarding/profile': {
      id: '/_auth/carriers/$slug/driver-onboarding/profile'
      path: '/driver-onboarding/profile'
      fullPath: '/carriers/$slug/driver-onboarding/profile'
      preLoaderRoute: typeof AuthCarriersSlugDriverOnboardingProfileRouteImport
      parentRoute: typeof AuthCarriersSlugRouteRoute
    }
    '/_auth/carriers/$slug/driver-onboarding/signed': {
      id: '/_auth/carriers/$slug/driver-onboarding/signed'
      path: '/driver-onboarding/signed'
      fullPath: '/carriers/$slug/driver-onboarding/signed'
      preLoaderRoute: typeof AuthCarriersSlugDriverOnboardingSignedRouteImport
      parentRoute: typeof AuthCarriersSlugRouteRoute
    }
  }
}

interface AuthCarriersSlugRouteRouteChildren {
  AuthCarriersSlugDriverOnboardingDashboardRoute: typeof AuthCarriersSlugDriverOnboardingDashboardRoute
  AuthCarriersSlugDriverOnboardingDocumentsRoute: typeof AuthCarriersSlugDriverOnboardingDocumentsRoute
  AuthCarriersSlugDriverOnboardingInsuranceCertificateRoute: typeof AuthCarriersSlugDriverOnboardingInsuranceCertificateRoute
  AuthCarriersSlugDriverOnboardingInsuranceQuoteRoute: typeof AuthCarriersSlugDriverOnboardingInsuranceQuoteRoute
  AuthCarriersSlugDriverOnboardingOnboardingRoute: typeof AuthCarriersSlugDriverOnboardingOnboardingRoute
  AuthCarriersSlugDriverOnboardingProfileRoute: typeof AuthCarriersSlugDriverOnboardingProfileRoute
  AuthCarriersSlugDriverOnboardingSignedRoute: typeof AuthCarriersSlugDriverOnboardingSignedRoute
}

const AuthCarriersSlugRouteRouteChildren: AuthCarriersSlugRouteRouteChildren = {
  AuthCarriersSlugDriverOnboardingDashboardRoute:
    AuthCarriersSlugDriverOnboardingDashboardRoute,
  AuthCarriersSlugDriverOnboardingDocumentsRoute:
    AuthCarriersSlugDriverOnboardingDocumentsRoute,
  AuthCarriersSlugDriverOnboardingInsuranceCertificateRoute:
    AuthCarriersSlugDriverOnboardingInsuranceCertificateRoute,
  AuthCarriersSlugDriverOnboardingInsuranceQuoteRoute:
    AuthCarriersSlugDriverOnboardingInsuranceQuoteRoute,
  AuthCarriersSlugDriverOnboardingOnboardingRoute:
    AuthCarriersSlugDriverOnboardingOnboardingRoute,
  AuthCarriersSlugDriverOnboardingProfileRoute:
    AuthCarriersSlugDriverOnboardingProfileRoute,
  AuthCarriersSlugDriverOnboardingSignedRoute:
    AuthCarriersSlugDriverOnboardingSignedRoute,
}

const AuthCarriersSlugRouteRouteWithChildren =
  AuthCarriersSlugRouteRoute._addFileChildren(
    AuthCarriersSlugRouteRouteChildren,
  )

interface AuthRouteRouteChildren {
  AuthErrorRoute: typeof AuthErrorRoute
  AuthNotFoundRoute: typeof AuthNotFoundRoute
  AuthUnauthorizedRoute: typeof AuthUnauthorizedRoute
  AuthCarriersSlugRouteRoute: typeof AuthCarriersSlugRouteRouteWithChildren
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthErrorRoute: AuthErrorRoute,
  AuthNotFoundRoute: AuthNotFoundRoute,
  AuthUnauthorizedRoute: AuthUnauthorizedRoute,
  AuthCarriersSlugRouteRoute: AuthCarriersSlugRouteRouteWithChildren,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRouteRoute: AuthRouteRouteWithChildren,
  CarriersRoute: CarriersRoute,
  LoginRoute: LoginRoute,
  MagicLoginRoute: MagicLoginRoute,
  CarrierOnboardTokenRoute: CarrierOnboardTokenRoute,
  OnboardConfirmJoinRoute: OnboardConfirmJoinRoute,
  TenantSlugDriverOnboardingSplatRoute: TenantSlugDriverOnboardingSplatRoute,
  OnboardFlowTokenCreateAccountRoute: OnboardFlowTokenCreateAccountRoute,
  OnboardFlowTokenSuccessRoute: OnboardFlowTokenSuccessRoute,
  OnboardFlowTokenIndexRoute: OnboardFlowTokenIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
